import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

//import { theme } from '@ecp/common/src/style/theme/default';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import Badge from '@ecp/common/src/components/badge/Badge';
import { TextBox } from '@ecp/common/src/text/TextBox';
import { userInfoState } from '@fo-recoil/common/user/atom';
import { useRecoilValue } from 'recoil';
import { useConfirmDialog } from '@fo-hooks/common/useModal';
import ButtonUnstyled from '@ecp/common/src/components/unstyled/button/ButtonUnstyled';
import  useLoginForward  from '@ecp/common/src/hooks/useLoginForward';
import useSiteInfo from '@fo-hooks/common/useSiteInfo';
const GnbIconButton2 = React.forwardRef(
  ({ iconType: Icon, badgeContent, label, selected, to, showZero, iconCount, unit }, ref) => {

    const {login} = useRecoilValue(userInfoState);
    const { siteNumber} = useSiteInfo();
    const { showConfirmDialog } = useConfirmDialog();
    const navigate = useNavigate();
    const loginForward = useLoginForward(siteNumber, showConfirmDialog);
    
    const handleLoginClick = () => {
        if (!login) {
          loginForward();
        } else {
          navigate(`${to}`);
        }
    }

    const theme = useTheme();
    const color = useMemo(
      () => ({
        icon: selected ? theme.color.icon.current : theme.color.icon.normal,
        label: selected ? theme.color.primary : theme.color.text.basic,
      }),
      [selected, theme.color.icon, theme.color.primary, theme.color.text.basic]
    );
    return (
      <ButtonUnstyled style={{ textDecoration: 'none' }} onClick={handleLoginClick}>
        <Wrapper ref={ref}>
          <Badge
            badgeContent={badgeContent}
            position={{ top: -8, right: -8 }}
            size={{ width: '16px', height: '16px' }}
            showZero={showZero}
          >
            <Icon width={'20px'} height={'20px'} />
          </Badge>
          <Label color={color.label}>{label}</Label>
          <TextBox>{iconCount} {unit}</TextBox>
        </Wrapper>
        </ButtonUnstyled>
    );
  }
);
export default GnbIconButton2;

GnbIconButton2.propTypes = {
  iconType: PropTypes.elementType,
  badgeContent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  selected: PropTypes.bool,
  showZero: PropTypes.bool,
  to: PropTypes.string,
  iconCount:PropTypes.number,
  unit:PropTypes.string,
};

GnbIconButton2.defaultProps = {
  selected: false,
  showZero: false,
};

GnbIconButton2.displayName = 'GnbIconButton2';

const Wrapper = styled(FlexBox)`
  width: fit-content;
  height: 36px;
  gap: 3px;
  cursor: pointer;
`;

const Label = styled.span.attrs(({ color, style }) => ({ style: { ...style, color } }))`
  font-size: 11px;
  line-height: 11px;
  font-weight: ${(props) => props.theme.font.weight.demiLight};
`;
